import { useEffect, useState } from 'react';

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const mql = window.matchMedia(query);

    // Mise à jour immédiate au premier rendu client
    setMatches(mql.matches);

    const listener = (e: MediaQueryListEvent | MediaQueryList) => {
      // e peut être un event (avec .matches) ou mql lui-même selon le fallback
      setMatches(e.matches);
    };

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', listener as EventListener);
      return () => mql.removeEventListener('change', listener as EventListener);
    } else {
      // Fallback pour anciens navigateurs
      mql.addListener(listener);
      return () => {
        mql.removeListener(listener);
      };
    }
  }, [query]);

  return matches;
}

// Utilisation conseillée (compat max)
export const useIsLg = () => useMediaQuery('(min-width: 1024px)');
export const useIsMd = () => useMediaQuery('(min-width: 768px)');

export default useMediaQuery;
